import * as Yup from 'yup';
import { ERROR_MESSAGES } from './types';

export const emailValidationSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .required(ERROR_MESSAGES.VALIDATION.EMAIL_REQUIRED)
    .email(ERROR_MESSAGES.VALIDATION.EMAIL_INVALID),
});

export interface EmailValidationResult {
  isValid: boolean;
  error: string | null;
}

export function validateEmail(email: string): EmailValidationResult {
  try {
    emailValidationSchema.validateSync({ email });
    
    return {
      isValid: true,
      error: null,
    };
  } catch (error) {
    if (error instanceof Yup.ValidationError) {
      return {
        isValid: false,
        error: error.message,
      };
    }
    
    return {
      isValid: false,
      error: ERROR_MESSAGES.VALIDATION.EMAIL_INVALID,
    };
  }
}
